import { classNames } from 'primereact/utils';
import { ButtonGroupPassThroughOptions } from 'primereact/buttongroup';

export const PTButtonGroup: ButtonGroupPassThroughOptions = {
  root: () => ({
    className: classNames('ax-button-group'),
  }),
};
